import { render, staticRenderFns } from "./FormQuizzBasicInfo.vue?vue&type=template&id=2f36f8de&scoped=true&"
import script from "./FormQuizzBasicInfo.vue?vue&type=script&lang=js&"
export * from "./FormQuizzBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormQuizzBasicInfo.vue?vue&type=style&index=0&id=2f36f8de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f36f8de",
  null
  
)

export default component.exports